import React from 'react';
import { Box, Card, CardContent, Divider, Skeleton, useTheme } from '@mui/material';

// utils
import { useUserRolePermissions } from 'hooks';
import { EvaluateFlag } from 'common/FeatureFlags/Flag';

const cardStyles = theme => ({
  boxShadow: theme.shadows[5],
  margin: theme.spacing(1),
  minHeight: 234,
  [theme.breakpoints.down('sm')]: {
    margin: `${theme.spacing(1)} ${theme.spacing(1)} 0`,
    width: '100%',
  },
  width: '308px',
});
const contentStyles = theme => ({
  '&:last-child': {
    paddingBottom: theme.spacing(2),
  },
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});

const AuthSequencingCardSkeleton = () => {
  const inCardEditingFlag = EvaluateFlag(
    process.env.REACT_APP_LD_AUTHORIZATION_SEQUENCING_IN_CARD_EDITING
  );
  if (inCardEditingFlag) {
    return <InCardEditingAuthSequencingCardSkeleton />;
  }

  const theme = useTheme();
  const { isProductLoadingManage, isSupplier } = useUserRolePermissions();

  return (
    <Card sx={cardStyles(theme)}>
      <CardContent sx={contentStyles(theme)}>
        <Box
          color={theme.palette.primary.dark}
          data-testid="skeleton"
          display="flex"
          height="48px"
          justifyContent="space-between"
          pb={2}
        >
          <Skeleton height="100%" variant="rectangular" width="100%" />
        </Box>
        <Box display="flex" justifyContent="space-between">
          <Divider sx={{ width: '47%' }} />
          <Divider sx={{ width: '47%' }} />
        </Box>
        <Box display="flex" height="60px" justifyContent="space-between">
          <Box alignItems="center" display="flex" flexDirection="column" pt="10px" width="47%">
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Box>
          <Box alignItems="center" display="flex" flexDirection="column" pt="10px" width="47%">
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Box>
        </Box>
        <Box mt={1}>
          <Box alignItems="center" display="flex" height="70px" justifyContent="center">
            <Skeleton height="100%" variant="rectangular" width="100%" />
          </Box>
          {isProductLoadingManage && isSupplier && (
            <Box
              alignItems="center"
              data-testid="managerSection"
              display="flex"
              height="70px"
              justifyContent="center"
              pb={1}
              pt={2}
            >
              <Skeleton
                height="calc(100% - 10px)"
                sx={{ borderRadius: '25px' }}
                variant="rectangular"
                width="91px"
              />
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};

const InCardEditingAuthSequencingCardSkeleton = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', p: 1, position: 'relative' }}>
      <Card sx={{ borderRadius: '4px', width: '430px' }}>
        {/* Header */}
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            height: '64px',
            justifyContent: 'space-between',
            p: 2,
          }}
        >
          <Skeleton height="32px" variant="rectangular" width="200px" />
          <Skeleton height="32px" variant="rectangular" width="60px" />
        </Box>

        {/* Content */}
        <CardContent sx={{ p: 0 }}>
          <Box sx={{ p: 2 }}>
            <Skeleton height="100px" variant="rectangular" width="100%" />
          </Box>
        </CardContent>

        {/* Footer */}
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            p: 2,
          }}
        >
          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'space-between', width: '100%' }}>
            <Skeleton height="36px" variant="rectangular" width="100px" />
            <Skeleton height="36px" variant="rectangular" width="100px" />
          </Box>
        </Box>
      </Card>
    </Box>
  );
};

export default AuthSequencingCardSkeleton;
